export default {
  acceptedImgMemeTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  acceptedImgFileExtensions: ['jpg', 'jpeg', 'png', 'gif', 'webp']
};